import type React from "react";
import { useId } from "react";
import { getColor, type Props } from "~/components/icons/helper";

export const LockIcon: React.FC<Props> = ({ color }) => {
	const id = useId();

	return (
		<svg
			role="img"
			aria-label="Lock"
			width="26"
			height="30"
			viewBox="0 0 26 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath={`url(#${id})`}>
				<path
					d="M23.3763 10.7241H2.62361C1.50096 10.7241 0.590881 11.6237 0.590881 12.7335V27.4064C0.590881 28.5161 1.50096 29.4157 2.62361 29.4157H23.3763C24.499 29.4157 25.4091 28.5161 25.4091 27.4064V12.7335C25.4091 11.6237 24.499 10.7241 23.3763 10.7241Z"
					stroke={getColor(color)}
					strokeMiterlimit="10"
					strokeLinecap="round"
				/>
				<path
					d="M14.7727 18.3178C14.7727 17.35 13.9791 16.5654 13 16.5654C12.021 16.5654 11.2273 17.35 11.2273 18.3178V21.8224C11.2273 22.7902 12.021 23.5748 13 23.5748C13.9791 23.5748 14.7727 22.7902 14.7727 21.8224V18.3178Z"
					stroke={getColor(color)}
					strokeMiterlimit="10"
					strokeLinecap="round"
				/>
				<path
					d="M21.8637 10.7243V9.38082C21.8637 7.05708 20.9298 4.82851 19.2676 3.18538C17.6053 1.54225 15.3508 0.619141 13 0.619141C10.6493 0.619141 8.39471 1.54225 6.73246 3.18538C5.07021 4.82851 4.13641 7.05708 4.13641 9.38082V10.7593"
					stroke={getColor(color)}
					strokeMiterlimit="10"
					strokeLinecap="round"
				/>
			</g>
			<defs>
				<clipPath id={id}>
					<rect width="26" height="30" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
